/**
 *
 * Asynchronously loads the component for AccountSettings
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
